import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';

 const Topical = (props) => (
   <SvgIcon {...props}>
        <g>
            <path fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
                M3,15.6l4.32-1.08c0,0,3.605,0.927,4.32,1.08c0.686,0.147,1.26,0.565,1.26,1.26s-0.565,1.26-1.26,1.26L7.297,17.4"/>
            <path fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
                M12.72,17.76l7.92-1.08c0.598,0,1.08,0.482,1.08,1.08c0,0.72-0.435,0.942-1.08,1.08C19.995,18.978,12.36,21,12.36,21L2.28,19.92"/>
            <path fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
                M16.32,9.84c0-3.252-3.24-6.84-3.24-6.84S9.84,6.588,9.84,9.84c0,1.796,1.451,3.24,3.24,3.24S16.32,11.636,16.32,9.84z"/>
            <path fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
                M17.768,17.072c1.654-0.226,1.871,2.016,0.425,2.393"/>
        </g>
   </SvgIcon>
);

export default Topical;



// WEBPACK FOOTER //
// ./src/icons/types/Topical.jsx